import { Component } from '@angular/core';

import '../../prism/prism.js';
import { LanguageSettings } from '../../providers/languageSettings.service';

declare var Prism;

@Component({
  selector: 'app-example-cashless-module',
  templateUrl: './example-cashless-module.html',
  styleUrls: ['../bleclassmodule/bleclassmodule.css']
})

/**
 * Class holding the example snippets for Cashless features.
 */
export class ExampleCashlessComponent {

/**
 * SG PLAYER PROFILE CALLBACK CONTENT
 */
JavaSGPlayerProfileCallbackPrism: string;
JavaSGPlayerProfileCallback="\
SGConnectBLE.addObserver(new SGPlayerProfileObserver() {\n\
  @Override\n\
  public void update(Enum status) {\n\
    //check pinSettingsAvailable, fundsTransferSupported and lastCashoutAvailable example functions to see proper use.\n\
    Log.i(\"TAG\",\"PlayerProfile available: \" + status.name());\n\
  }\n\
  \n\
  @Override\n\
  public void onError(SGError err) {\n\
      Log.e(\"TAG\",err.getErrorMessage());\n\
      \n\
  }\n\
});";

SwiftSGPlayerProfileCallbackPrism:string;
SwiftSGPlayerProfileCallback:string =
'SGConnectBLE.addObserver(onStateChange: onPlayerProfileUpdate)\n\
\n\
func onPlayerProfileUpdate(state: SGPlayerProfileState, error: SGError?) -> Void{\n\
    if (error == nil) {\n\
        print("Player Profile State:\\(state)")\n\
        if (state == .pinSettingAvailable){\n\
            print("Is Pin Required:\\(SGConnectBLE.isPrimaryIdentificationRequired()!)")\n\
        } else if (state == .fundTransferSettingAvailable){\n\
            print("Is Funds Transfer Enabled:\\(SGConnectBLE.isFundsTransferSupported()!)")\n\
        } else if (state == .lastCashoutAvailable){\n\
            let balance = SGConnectBLE.getLastCashout()\n\
            if (balance != nil){\n\
                print("Last cashout for \\(balance!.accountType): \\(balance!.amountInCents)")\n\
            }\n\
        }\n\
    } else {\n\
        print("Profile Update Error: \\(error!.type)")\n\
    }\n\
}';

JavaScriptSGPlayerProfileCallbackPrism:string;
JavaScriptSGPlayerProfileCallback:string = "\
SGConnectAPIPlugin.addObserver('SGPlayerProfileState', function(state){\n\
    //check pinSettingsAvailable, fundsTransferSupported and lastCashoutAvailable example functions to see proper use.\n\
    console.log('SGPlayerProfileState: ' + state);\n\
\n\
}, function(error){\n\
    console.log('Error - ' + JSON.parse(error).type);\n\
});"


/**
 * Get balance
 */
JavaGetBalancePrism:string;
JavaGetBalance:string = "\
public void onGetBalanceClicked(View v){\n\
  \n\
  SGConnectBLE.getBalances(new SGPlayerBalanceCallback() {\n\
      @Override \n\
      public void onBalanceAvailable(SGBalance[] sgBalances) {\n\
            if (sgBalances==null || sgBalances.length==0) {\n\
                Log.i(\"TAG\",\"No matching balances\");\n\
                return;\n\
            }\n\
          \n\
            for (int i = 0; i < sgBalances.length; i++){\n\
                Log.i(\"TAG\",\"AMMOUNT: \"+sgBalances[i].getAmountInCents());\n\
                Log.i(\"TAG\",\"DISPOSITION: \" + sgBalances[i].getDisposition());\n\
            }\n\
\n\
      }\n\
      \n\
      @Override\n\
      public void onError(SGError balanceError) {\n\
          Log.e(\"TAG\", \"BALANCE ERROR: \" + balanceError.getErrorType());\n\
      }\n\
\n\
  });\n\
}";

SwiftGetBalancePrism:string;
SwiftGetBalance:string = '\
SGConnectBLE.getBalances(onBalanceAvailable: onBalanceAvailable)\n\
\n\
func onBalanceAvailable(balances: [SGBalance], error: SGError?) -> Void{\n\
    if (error == nil) {\n\
        for balance in balances {\n\
            print("Balance for \\(balance.accountType): in \\(balance.disposition) is \\(balance.amountInCents)")\n\
        }\n\
    } else {\n\
        print("Balance Error: \\(error!.type)")\n\
    }\n\
}';

JavaScriptGetBalancePrism:string;
JavaScriptGetBalance:string = "\
document.getElementById('getBalances').addEventListener('click', function() {\n\
    SGConnectAPIPlugin.getBalances(function(balancesString){\n\
        var balances = JSON.parse(balancesString);\n\
        for (i = 0; i < balances.length; i++) {\n\
            console.log(balances[i].accountType + ':' + balances[i].amountInCents );\n\
        }\n\
    }, function(error){\n\
        console.log( 'Error - ' + JSON.parse(error).type );\n\
    });\n\
});";


/**
 * INIT TRANSFER
 */
JavaInitTransferPrism:string;
JavaInitTransfer:string = "\
SGConnectBLE.transferAmount(100,CommandDefinitions.SGAccountType.UWS, \n\
    CommandDefinitions.SGAccountType.EGM, \n\
    CommandDefinitions.SGFundType.CASH, \"7020\", new SGFundTransferCallback() {\n\
    @Override\n\
    public void onTransferComplete(final SGTransfer transfer) {\n\
        Log.i(\"TAG\", \"BALANCE \" + transfer.getAmmountInCents());\n\
        Log.i(\"TAG\", \"STATUS: \" + transfer.getStatus());\n\
        \n\
    }\n\
    \n\
    @Override\n\
    public void onError(final SGError transferError) {\n\
        Log.e(\"TAG\", \"TRANSFER ERROR: \" + transferError.getErrorType());\n\
    }\n\
    \n\
});";

SwiftInitTransferPrism:string;
SwiftInitTransfer:string =  '\
SGConnectBLE.transferAmount(inCents: 100, from: .EBS, to: .EGM, in: .cash, \nwithPrimaryIdentifier: "7020", andSecondaryIdentifier: nil, onTransferComplete: onTransferComplete)\n\
\n\
func onTransferComplete(error: SGError?) -> Void {\n\
    if (error == nil){\n\
        print("Transfer Successful.")\n\
    } else {\n\
        print("Transfer Error: \\(error!.type)")\n\
    }\n\
}';

JavaScriptInitTransferPrism:string;
JavaScriptInitTransfer:string = "\
document.getElementById('transferFunds').addEventListener('click', function() {\n\
\n\
  var fromAccount = 'EGM';\n\
  var toAccount = 'UWS';\n\
  var amountInCents = 1000;\n\
  var pin = 1234; \n\
  \n\
  SGConnectAPIPlugin.transferAmount(amountInCents, fromAccount, toAccount,'CASH', pin, undefined, function(){\n\
    console.log('funds transfer success');\n\
  }, \n\
  function(error){ //This is a json string and with keys = type, localizedDescription & debugInformation, values are strings\n\
    console.log('funds transfer failed:' + JSON.parse(error).type);\n\
  });\n\
});\n"

/**
 * is fund transfer supported
 */
JavaIsFundsSupportedPrism:string;
JavaIsFundsSupported:string = "\
public void onInitiateTransferClicked(View v){\n\
  if (SGConnectBLE.isFundsTransferSupported()==true){\n\
    Log.i(\"TAG\",\"Fund transfer supported\");\n\
    Log.i(\"TAG\",\"initiating fundtransfer..\");\n\
  }else  \n\
  if (SGConnectBLE.isFundsTransferSupported()==false){\n\
    Log.i(\"TAG\",\"Fund transfer is not supported\");\n\
  }  \n\
  if (SGConnectBLE.isFundsTransferSupported()==null){\n\
    Log.w(\"TAG\",\"Cannot determine because session has not been created\");\n\
  }  \n\
}\n\
";

SwiftIsFundsSupportedPrism: string;
SwiftIsFundsSupported = 'func onPlayerProfileUpdate(state: SGPlayerProfileState, error: SGError?) -> Void{\n\
    if (state == .fundTransferSettingAvailable){\n\
        print("Is Funds Transfer Enabled:\\(SGConnectBLE.isFundsTransferSupported()!)")\n\
    } \n\
}';

JavaScriptIsFundsSupportedPrism:string;
JavaScriptIsFundsSupported:string = "\
SGConnectAPIPlugin.isFundsTransferSupported(function(hasSupport){ \n\
  console.log('funds transfer supported: ',hasSupport) ; \n\
});";

/**
 * Is primary identification required
 */
JavaIsPrimaryRequiredPrism:string;
JavaIsPrimaryRequired:string = "\
public void onInitiateTransferClicked(View v){\n\
  if (SGConnectBLE.isPrimaryIdentificationRequired()==true){\n\
    Log.i(\"TAG\",\"Primary identification requried\");\n\
  }else  \n\
  if (SGConnectBLE.isPrimaryIdentificationRequired()==false){\n\
    Log.i(\"TAG\",\"Primary identification not required\");\n\
  }  \n\
  if (SGConnectBLE.isPrimaryIdentificationRequired()==null){\n\
    Log.w(\"TAG\",\"Cannot determine because session has not been created\");\n\
  }  \n\
}\n\
";

SwiftIsPrimaryRequiredPrism: string;
SwiftIsPrimaryRequired = 'func onPlayerProfileUpdate(state: SGPlayerProfileState, error: SGError?) -> Void{\n\
    if (state == .pinSettingAvailable){\n\
        print("Is Pin Required:\\(SGConnectBLE.isPrimaryIdentificationRequired()!)")\n\
    }\n\
}';

JavaScriptIsPrimaryRequiredPrism:string;
JavaScriptIsPrimaryRequired:string = "\
SGConnectAPIPlugin.isPrimaryIdentificationRequired(function(hasSupport){ \n\
  console.log('primary identification required: ', hasSupport); \n\
});";


JavaGetLastCashoutPrism:string;
JavaGetLastCashout:string = "\
/** \n\
 * it is recommended you only request for the last cashout after it is available. \n\
 * This example includes using the the SGPlayerProfileObserver  \n\
 * to automatically get an update of it's availability \n\
 */ \n\
SGConnectBLE.addObserver(new SGPlayerProfileObserver() { \n\
  @Override \n\
  public void update(Enum status) { \n\
      if (status==Constants.SGPlayerProfileState.LASTCASHOUTAVAILABLE){ \n\
          SGBalance lastCashout = SGConnectBLE.getLastCashout(); \//\get the last cashout \n\
          int amount = 0; \n\
          if (lastCashout!=null) \n\
          amount = lastCashout.getAmountInCents(); \n\
          \n\
          Log.i(\"TAG\",\"Amount in cents: \" + amount); \n\
      } \n\
  } \n\
  \n\
  @Override \n\
  public void onError(SGError err) { \n\
    Log.e(\"TAG\",err.getErrorMessage()); \n\
  } \n\
}); \n\
"

JavaScriptGetLastCashoutPrism:string;
JavaScriptGetLastCashout:string = "\
/** \n\
 * it is recommended you only request for the last cashout after it is available. \n\
 * This example includes using the the SGPlayerProfileObserver  \n\
 * to automatically get an update of it's availability \n\
 */ \n\
SGConnectAPIPlugin.getLastCashout(function(lastCashoutString){ \n\
  var lastCashout = JSON.parse(lastCashoutString);\n\
  console.log(lastCashout.accountType + ':' + lastCashout.amountInCents);\n\
});\n\
";

SwiftGetLastCashoutPrism: string;
SwiftGetLastCashout = '\
func onPlayerProfileUpdate(state: SGPlayerProfileState, error: SGError?) -> Void{\n\
  if (state == .lastCashoutAvailable){\n\
      let balance = SGConnectBLE.getLastCashout()\n\
      if (balance != nil){\n\
          print("Last cashout for \\(balance!.accountType) is \\(balance!.amountInCents) cents.")\n\
      }\n\
  }\n\
}';

  constructor(public languageSettings: LanguageSettings) {
    this.applyPrism();
  }

  applyPrism() {
    this.JavaGetBalancePrism = Prism.highlight(this.JavaGetBalance, Prism.languages.java);
    this.JavaInitTransferPrism = Prism.highlight(this.JavaInitTransfer, Prism.languages.java);
    this.JavaIsFundsSupportedPrism = Prism.highlight(this.JavaIsFundsSupported, Prism.languages.java);
    this.JavaIsPrimaryRequiredPrism = Prism.highlight(this.JavaIsPrimaryRequired, Prism.languages.java);
    this.JavaGetLastCashoutPrism = Prism.highlight(this.JavaGetLastCashout, Prism.languages.java);
    this.JavaSGPlayerProfileCallbackPrism = Prism.highlight(this.JavaSGPlayerProfileCallback, Prism.languages.java);

    this.SwiftGetBalancePrism = Prism.highlight(this.SwiftGetBalance, Prism.languages.swift);
    this.SwiftInitTransferPrism = Prism.highlight(this.SwiftInitTransfer, Prism.languages.swift);
    this.SwiftIsFundsSupportedPrism = Prism.highlight(this.SwiftIsFundsSupported, Prism.languages.swift);
    this.SwiftIsPrimaryRequiredPrism = Prism.highlight(this.SwiftIsPrimaryRequired, Prism.languages.swift);
    this.SwiftSGPlayerProfileCallbackPrism = Prism.highlight(this.SwiftSGPlayerProfileCallback, Prism.languages.swift);
    this.SwiftGetLastCashoutPrism = Prism.highlight(this.SwiftGetLastCashout, Prism.languages.swift);

    this.JavaScriptGetBalancePrism = Prism.highlight(this.JavaScriptGetBalance, Prism.languages.javascript);
    this.JavaScriptInitTransferPrism = Prism.highlight(this.JavaScriptInitTransfer, Prism.languages.javascript);
    this.JavaScriptIsFundsSupportedPrism = Prism.highlight(this.JavaScriptIsFundsSupported, Prism.languages.javascript);
    this.JavaScriptIsPrimaryRequiredPrism = Prism.highlight(this.JavaScriptIsPrimaryRequired, Prism.languages.javascript);
    this.JavaScriptSGPlayerProfileCallbackPrism = Prism.highlight(this.JavaScriptSGPlayerProfileCallback, Prism.languages.javascript);
    this.JavaScriptGetLastCashoutPrism = Prism.highlight(this.JavaScriptGetLastCashout, Prism.languages.javascript);
  }

}
